<dx-popover
    [(visible)]="isVisible"
    class="app-note-rilascio-container"
    [target]="target"
    position="right"
>
    @if (
        {
            isIntegration: isIntegration$ | async,
            versioneFe: feVersion$ | async
        };
        as data
    ) {
        <div class="app-note-rilascio-title">
            Bilancio V.{{ data.versioneFe }}
        </div>
        <div class="app-note-rilascio-description">
            Puoi accedere alle note di rilascio
        </div>
        <div class="app-note-rilascio-description">
            aggiornate con le funzionalità
        </div>
        <div class="app-note-rilascio-description">
            attualmente disponibili.
        </div>
        <div class="app-note-rilascio-button">
            <bil-button (onClick)="onButtonReleaseNoteClick(data.versioneFe)"
                >Vedi note di rilascio</bil-button
            >
        </div>
        <div class="app-note-rilascio-cta">
            @if (data.isIntegration) {
                <span id="videoIntroduttivoBilancio" style="cursor: pointer">
                    Scopri come operare su bilancio
                </span>
            } @else {
                <span>&nbsp;</span>
            }
        </div>
    }
</dx-popover>
